export default __webpack_public_path__ + "static/media/logo-white.bcee912b.svg";